import { createStyles } from "@mantine/emotion";

import { rooterMediaQuery } from "_styles/theme/mediaQuery";

export default createStyles ( ( theme, _, u ) => ( {
	svg: {
		...theme.other.svgIcons.size25
	},
	paddingLeft: {
		paddingLeft: "10px"
	},
	titleContainer: {
		marginTop: "2rem",

		[rooterMediaQuery.mobile]: {
			margin: "1.25rem 1rem"
		}
	},
	gridContainer: {
		display                       : "grid",
		gridColumnGap                 : "1.5rem",
		gridRowGap                    : "1rem",
		margin                        : "1rem 1.5rem 0 1rem",
		gridTemplateColumns           : "repeat(3, 1fr)",
		[u.smallerThan ( undefined )] : {
			gridTemplateColumns: "repeat(2, 1fr)"
		}
	},
	imgContainer: {
		cursor                  : "pointer",
		WebkitTapHighlightColor : "transparent",
		position                : "relative",
		boxSizing               : "border-box",
		"&::before"             : {
			content       : "''",
			display       : "block",
			height        : "0",
			width         : "0",
			paddingBottom : "80%"
		}
	},
	imgContent: {
		position : "absolute",
		top      : "0",
		left     : "0",
		height   : "100%",
		width    : "100%"
	},
	videoListContainer: {
		display             : "grid",
		gridTemplateColumns : "repeat(auto-fit, minmax(275px, 1fr))",
		gridGap             : "3rem 1.5rem",
		padding             : "2rem 0",

		[rooterMediaQuery.mobile]: {
			padding      : "unset",
			marginBottom : "6rem"
		}
	}
} ) );
